import * as types from '@/store/mutation-types'
import { Setup } from '@/skeletons/modal'

const state = {
  show: false,
  filter: {},
  modalContent: {}
}

const getters = {
  show: state => state.show,
  content: state => state.modalContent,
  filtersSelected: state => state.filter
}

const actions = {
  launchModalWithData ({ commit }, data) {
    if (!data.orders.length || !Array.isArray(data.orders)) return false

    const setup = Setup(data.type.call)
    const content = setup.callStructureModal()

    const orderIds = data.orders.map(order => order.id)
    const orderCodes = data.orders.map(order => order.supplierOrderCode)

    let orders = data.orders.map(order => {
      const {
        id,
        customerOrderCode,
        supplierOrderCode,
        volume,
        volumeTotal,
        palletTotal,
        palletEquivalentNumber,
        palletEquivalentForPartner,
        partnerFeature,
        weight,
        communicationStatus,
        partner,
        possibleToRevert
      } = order

      return {
        id,
        customerOrderCode,
        supplierOrderCode,
        volume,
        volumeTotal,
        palletTotal,
        palletEquivalentNumber,
        palletEquivalentForPartner,
        partnerFeature,
        weight,
        communicationStatus,
        partner,
        possibleToRevert
      }
    })

    content.type = data.type
    content.body = {
      orderIds,
      orderCodes,
      orders
    }

    commit(types.LAUNCH_MODAL, content)
  },
  enable ({ commit }) {
    commit(types.START_MODAL)
  },
  disable ({ commit }) {
    commit(types.STOP_MODAL)
  },
  flush ({ commit }) {
    commit(types.CLEAN_MODAL)
  }
}

const mutations = {
  [types.LAUNCH_MODAL] (state, modalContent) {
    state.show = true
    state.modalContent = { ...modalContent }
  },
  [types.START_MODAL] (state) {
    state.show = true
  },
  [types.STOP_MODAL] (state) {
    state.show = false
  },
  [types.CLEAN_MODAL] (state) {
    state.modalContent = {}
    state.show = false
    state.filter = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/modal.js